export const buildCoinUrl = (slug: string) => `/coin/${slug}/`;

export const buildExchangeUrl = (slug: string) => `/exchange/${slug}/`;

export const buildCategoryUrl = (slug: string) => `/category/${slug}/`;
